var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLomasetapa5Horizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 45.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.3,
    cy: 30.4,
    r: 0.3,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,12c0,6.6-5.4,12-12,12s-12-5.4-12-12C15,5.4,20.4,0,27,0s12,5.4,12,12",
    fill: "#ecca20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7,16.3h6.1s2.2,2,2.2,6.2-1.6,8.4.3,12.2c-1.4,2-4.6,3.2-4.6,3.2l-4.9-1.2s-1.7-1.3-.1-7.1c1.6-5.8,2.7-9.5,1.1-13.2",
    fill: "#82b627"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6,25.9h1.2c0-.2,0-.4.1-.6h-1.3c0,.3,0,.5-.1.6",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,24.6h1.3c0-.2,0-.4.1-.6h-1.3c0,.2,0,.4,0,.6",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19,22.7c0,.2,0,.4,0,.6h1.3c0-.2,0-.4,0-.6h-1.3Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19,22h1.3c0-.2,0-.4,0-.6h-1.3c0,.2,0,.4,0,.6",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9,20.7h1.3c0-.2,0-.4-.1-.6h-1.3c0,.2,0,.4,0,.6",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20,19.4c0-.2-.1-.4-.2-.6h-1.2c0,.2.1.4.2.6h1.3Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,14.6h6.1s2.2,2,2.2,6.1-1.6,8.4.3,12.2c-1.4,1.9-4.6,3.2-4.6,3.2l-4.9-1.2s-1.7-1.3-.1-7.2c1.6-5.8,2.7-9.5,1.1-13.2",
    fill: "#009140"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3,12.7h6.4s2.4,2.5,2.4,6.7-1.7,9.6.3,13.4c-1.5,1.9-4.9,1.5-4.9,1.5h-4.3c0,0-2.7-2.4-1-8.2,1.7-5.8,2.9-9.6,1.2-13.3",
    fill: "#0f6b35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,22.7h1.5c0-.2.1-.5.2-.8h-1.4c0,.3-.2.6-.3.8",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,21.4h1.4c0-.3.1-.5.2-.8h-1.4c0,.3-.1.6-.2.8",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8,20.1h1.4c0-.3.1-.6.1-.8h-1.3c0,.3,0,.6-.2.8",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7,18.6c0,0,0,.1,0,.2h1.4c0-.2,0-.4,0-.5s0-.2,0-.3h-1.3c0,.2,0,.4,0,.6",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1,17.5h1.3c0-.3,0-.6,0-.8h-1.3c0,.3,0,.5,0,.8",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3,16.2c0-.3,0-.6-.1-.8h-1.3c0,.2,0,.5.1.8h1.3Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,16.9c-.3.1-.5-.2-.8,0-.3.2,0,.7-.2.8-.2.1-.3-.2-.7,0-.6.4,0,.6-.1.7-.1.1-1,.2-1.2.8-.2.6.4.6.3.9-.1.3-.5,0-.7.3-.2.4.1.5,0,.6,0,.1-.3,0-.3.6,0,.5-.5-.5-.7.8,0,.4.5.6.5.9,0,.2-.8.2-.6.8.2.6.6,0,.6.2,0,.3-.4.6,0,1,.5.4.5,0,.6.2.1.2,0,.6.7.8.7.2,1.7,0,2.3.2.6.3.7.2,1,0,.4-.2.4-.7,1-.6.6.1,1,0,1.4-.3s.4-.3.9-.1c.5,0,.7,0,.8-.4.1-.4-.3-.9-.2-1.1.1-.2.7,0,.8-.5,0-.6-.9-1.1-.8-1.5,0-.2.5.3.4-.4,0,0-.2,0-.3-.2-.2-.2-.2-.6-.5-.6-.2,0-.4-.1-.1-.2.3,0,.4-.4.2-.5-.2,0-.5,0-.5-.2,0-.2.4-.1.2-.5s-.8-.5-.8-.7c0-.2.5-.3.2-.6-.3-.3-.8-.3-1.1-.3-.3,0,0-.2-.4-.4-.4-.2-.4,0-.6,0-.2,0-.1-.6-.6-.7-.4,0-.6.3-.6.3",
    fill: "#009140"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3,26.4c0,.3.1.7-.2,1.1-.4.4.3.3,1.4.4,1,0,.1-.2.2-.8,0-.5,0-1.5,0-1.5l-1.4.7",
    fill: "#0f7538"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7,25.9c-.3,0-.6.2-.6.2-.2.3-.4.5-.1.7.3.1.3.3.2.4-.1.2-.1.2,0,.4,0,0,.2.2.3.3.9,0,0-.2,0-.8,0-.3,0-.8,0-1.1",
    fill: "#0f6b35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3,17.3c0,.2,0,.5-.1.7-.3.4-.7.6-.3.9.3.3,1.4.8,1.4,1.2,0,.6-1.1.7-1.2,1.1,0,.5,1.3.5,1.1,1.2-.3,1.1-2.6.5-2.7,1.4,0,.5,1.5.3.5,1.3-.9.9-2.5,1.1-3.4,1.2,0,0,0,0,.2,0,.7.2,1.7,0,2.3.2.6.3.7.2,1,0,.4-.2.4-.7,1-.6.6.1,1,0,1.4-.3s.4-.3.9-.1c.5,0,.7,0,.8-.4.1-.4-.3-.9-.2-1.1.1-.2.7,0,.8-.5,0-.6-.9-1.1-.8-1.5,0-.2.5.3.4-.4,0,0-.2,0-.3-.2-.2-.2-.2-.6-.5-.6s-.4-.1-.1-.2c.3,0,.4-.4.2-.5-.2,0-.5,0-.5-.2,0-.2.4-.1.2-.5s-.8-.5-.8-.7c0-.2.5-.3.2-.6-.3-.3-.8-.3-1.1-.3-.3,0,0-.2-.4-.4",
    fill: "#0f6b35"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,27.5c0,.2,0,.4,0,.5-.2.2-.4.4-.4.4,0,0,.9-.1,1-.2.1,0,.2-.2.2-.4,0-.2,0-.5,0-.6,0-.1-.7.3-.7.3",
    fill: "#0f7538"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6,27.8c0-.1,0-.3,0-.4,0,0-.2.1-.3.2-.2.1.1,0,0,.4,0,.2,0,.2.2,0,0,0,0-.2,0-.3",
    fill: "#0f6b35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7,27.3s.4,0,.6,0c.3,0,.3-.3.6-.2.3,0,.6,0,.6-.3,0-.2-.1-.4,0-.5,0-.1.3-.1.3-.4s-.3-.4-.3-.8c0-.4.1,0,0-.4-.2-.4-.3-.2-.4-.4,0-.2.2,0,.2-.2,0-.1-.3,0-.3-.2,0-.2.2-.2,0-.4-.2-.2-.3,0-.3-.3,0-.2.2-.2,0-.3-.2-.2-.4,0-.5,0,0-.1,0-.2-.1-.3-.2-.1-.3.1-.4,0,0-.1-.2-.5-.6-.3-.1,0-.4-.1-.5.1-.2.2,0,.3-.2.4-.1,0-.3-.1-.5.2-.1.3.2.3,0,.3-.2,0-.5,0-.6.4,0,.3.2.3.1.5,0,.2-.3,0-.4.3,0,.2,0,.3,0,.4-.1.1,0,0-.2.2-.2.1-.3.3-.3.6,0,.2.2.2.2.4s-.3,0-.2.3c0,.2.2,0,.2.2,0,.2-.2.3,0,.5.1.2.4,0,.5.1.1.2,0,.4.4.5.3,0,.8-.1,1.1,0,.2.1.3.2.6.1.2,0,.3-.2.6-.3",
    fill: "#009140"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,25.9c0-.3-.3-.4-.3-.8,0-.4.1,0,0-.4-.2-.4-.3-.2-.4-.4,0-.2.2,0,.2-.2,0-.1-.3,0-.3-.2,0-.2.2-.2,0-.4-.2-.2-.3,0-.3-.3,0-.2.2-.2,0-.3-.2-.2-.4,0-.5,0,0-.1,0-.2-.1-.3,0,0,0,0,0,0,0,.1,0,.2,0,.4-.2.3-.3.4-.1.6.2.2.8.4.7.7,0,.3-.6.4-.6.6s.6.3.5.7c0,.3-1.4.3-1.5.7,0,.4.8.1.4.7-.4.5-1.4.6-1.9.7,0,0,0,0,.1,0,.3,0,.8-.1,1.1,0,.2.1.3.2.6.1.2,0,.3-.2.6-.3,0,0,.4,0,.6,0,.3,0,.3-.3.6-.2.3,0,.6,0,.6-.3,0-.2-.1-.4,0-.5,0-.1.3-.1.3-.4",
    fill: "#0f6b35"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0,31.4s3.7,2.2,9,2.2,14.1-6.4,24.4-6.4,14.3,5.1,14.3,5.1v4.5s-7.1-4.4-12.1-4.4c-11,0-15.9,6.2-24.8,6.2s-10.9-2.8-10.9-2.8v-4.6Z",
    fill: "#b7ca13"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,32.6c5,0,12.1,4.4,12.1,4.4v-.6c-2.3-1.8-8.5-5.9-15.2-5.9s-16.5,6.4-24.1,6.4S1.7,35.7,0,35v1s4.1,2.8,10.9,2.8,13.8-6.2,24.8-6.2",
    fill: "#009140"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,32.6c5,0,12.1,4.4,12.1,4.4v-.3c-7.2-4.9-12.5-5.7-17.9-4.9-5.5.9-12,5.9-21.9,6C4.8,37.8,1,36.1,0,35.6v.4s4.1,2.8,10.9,2.8,13.8-6.2,24.8-6.2",
    fill: "#0f6b35"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.4,
    y: 20.9,
    width: 37.9,
    height: 5.7,
    fill: "#93b63a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4,6.1c0,1.4-1.1,2.4-2.4,2.4s-2.5-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4,1.3,0,2.4,1.1,2.4,2.4",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8,6.1c0,1-.8,1.9-1.9,1.9s-1.9-.8-1.9-1.9.8-1.9,1.9-1.9,1.9.8,1.9,1.9",
    fill: "#e4ca3b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.4 2.5 54.4 9.6 56.1 9.6 56.1 10.6 53.4 10.6 53.4 2.5 54.4 2.5",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.6 7.5 66.8 2.3 68.6 10.6 67.6 10.6 66.5 5.3 64.6 10 62.6 5.3 61.6 10.6 60.6 10.6 62.3 2.3 64.6 7.5",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6,10.6h-1l-.9-2.6h-1.8l-.8,2.6h-1l2.7-8.2,2.7,8.2ZM71.8,4.9l-.6,2.1h1.2l-.6-2.1Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,3.5c-.3-.2-.6-.2-.9-.2-.5,0-.9.3-.9.8s.1.4.4.6c.1,0,.2.1.8.3.7.2,1.1.4,1.4.7.6.5,1,1.4,1,2.2,0,1.6-1.3,2.9-2.9,2.9s-1.1-.1-1.8-.7v-1.5c.2.4.4.5.6.7.4.3.9.5,1.3.5,1.1,0,2-.9,2-1.9s-.4-1.4-1-1.7c-.2-.1-.3-.2-1.1-.4-.6-.2-.9-.3-1.2-.6-.3-.3-.4-.7-.4-1.1,0-1,.8-1.7,1.8-1.7.3,0,.5,0,.9.2v1Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,2.2c1,0,1.8.3,2.6.9,1,.8,1.7,2,1.7,3.4s-.8,3-2.1,3.7c-.7.4-1.3.5-2.1.6V2.2ZM84.7,9.6c1.3-.4,2.3-1.7,2.3-3.1s-1-2.8-2.3-3.1v6.3Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.4 2.3 91.4 3.3 89.6 3.3 89.6 5.3 90.9 5.3 90.9 6.2 89.6 6.2 89.6 9.6 91.4 9.6 91.4 10.6 88.7 10.6 88.7 2.3 91.4 2.3",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,19c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2v.7c-.4,0-.7,0-1,.3-.9.5-1.4,1.3-1.4,2.2s.5,1.8,1.4,2.2c.4.2.6.2,1,.3v.7Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8,18.9h-.8l-.7-2h-1.3l-.6,2h-.7l2-6.3,2.1,6.3ZM58.7,14.6l-.4,1.6h.9l-.5-1.6Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4,12.8c.8,0,1,0,1.5.3.6.4.9,1,.9,1.7s-.3,1.3-.8,1.7l1.4,2.5h-.8l-1.6-2.8c.7-.2,1.1-.7,1.1-1.3,0-.7-.5-1.3-1.2-1.3v5.4h-.7v-6.2h.3Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,18.9h-.8l-.7-2h-1.3l-.7,2h-.7l2.1-6.3,2.1,6.3ZM66.1,14.6l-.4,1.6h.9l-.5-1.6Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,12.8c.6,0,.9,0,1.2.3.3.3.5.7.5,1.1,0,.4-.1.7-.4.9.8.3,1.3,1,1.3,1.8,0,.7-.4,1.4-1,1.7-.3.2-.6.2-1.3.2h-.7v-6.2h.4ZM69.2,15c.4,0,.7-.4.7-.8s-.3-.7-.7-.8v1.5ZM69.4,18.2c.8,0,1.3-.5,1.3-1.2s-.6-1.3-1.4-1.3h-.1v2.5s.2,0,.2,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,18.9h-.8l-.7-2h-1.3l-.6,2h-.7l2.1-6.3,2.1,6.3ZM73.4,14.6l-.4,1.6h.9l-.5-1.6Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.9 12.8 77.9 15.2 77.9 18.9 77.2 18.9 77.2 15.2 75.2 12.8 76.1 12.8 77.5 14.5 78.9 12.8 79.9 12.8",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.9 12.8 80.9 18.2 82.2 18.2 82.2 18.9 80.1 18.9 80.1 12.8 80.9 12.8",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.4 12.8 83.4 18.2 84.7 18.2 84.7 18.9 82.7 18.9 82.7 12.8 83.4 12.8",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,15.8c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2,1.4-3.2,3.2-3.2,3.2,1.4,3.2,3.2M85.6,15.8c0,1.4,1.1,2.5,2.5,2.5,1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5c-1.3,0-2.4,1.1-2.4,2.5",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.2,25.5c-.1,0-.2-.2-.2-.3,0-.1,0-.2,0-.4v-2.5s0,0,0,0h.4s0,0,0,0v2.5c0,0,0,.1,0,.1,0,0,0,0,.1,0h1.2c0,0,.1,0,.1,0,0,0,0,0,0-.1v-2.5s0,0,0,0h.4s0,0,0,0v2.5c0,.1,0,.2,0,.4,0,.1-.1.2-.2.3-.1,0-.2,0-.3,0h-1.2c-.1,0-.2,0-.3,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,22.3h.3s0,0,0,0l1.6,2.2s0,0,0,0v-2.1s0,0,0,0h.4s0,0,0,0v3.2s0,0,0,0h-.3s0,0,0,0l-1.6-2.2s0,0,0,0v2.1s0,0,0,0h-.4s0,0,0,0v-3.2s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,22.3h.4s0,0,0,0v3.2s0,0,0,0h-.4s0,0,0,0v-3.2s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4,22.4l.9,2.6c0,0,0,0,.1,0l.9-2.6s0,0,0,0h.4s0,0,0,0l-1.1,3.2s0,0,0,0h-.5s0,0,0,0l-1.1-3.2s0,0,0,0h.4s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,22.3h2.3s0,0,0,0v.4s0,0,0,0h-1.9s0,0,0,0v.8s0,0,0,0h1.7s0,0,0,0v.4s0,0,0,0h-1.7s0,0,0,0v.8s0,0,0,0h1.9s0,0,0,0v.4s0,0,0,0h-2.3s0,0,0,0v-3.2s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4,24.5h-.8s0,0,0,0v1s0,0,0,0h-.4s0,0,0,0v-3.2s0,0,0,0h1.9c.1,0,.2,0,.3,0,0,0,.2.1.2.2,0,.1,0,.2,0,.3v.8c0,.2,0,.4-.2.5,0,.1-.2.2-.3.2s0,0,0,0l.6.9s0,0,0,0h-.4s0,0,0,0l-.7-1s0,0,0,0ZM70.9,24c0,0,.1,0,.1,0,0,0,0,0,0-.2v-.8c0,0,0-.1,0-.1s0,0-.1,0h-1.3s0,0,0,0v1.1s0,0,0,0h1.3Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,25.6c-.2,0-.4-.2-.5-.4s0-.2,0-.3v-.2s0,0,0,0h.4s0,0,0,0v.2c0,0,0,.1,0,.1,0,0,0,0,.1,0h1.2c0,0,.1,0,.1,0,0,0,0,0,0-.1v-.4c0,0,0-.1,0-.2s-.1,0-.2,0h-1.1c-.1,0-.2,0-.4,0-.1,0-.2-.2-.3-.3,0-.1,0-.2,0-.4v-.5c0-.1,0-.2,0-.3,0-.1.1-.2.2-.3.1,0,.2,0,.3,0h1.3s0,0,0,0c.2,0,.4.2.5.3,0,.1,0,.2,0,.3v.3h-.5v-.3c0,0,0-.1,0-.1,0,0,0,0-.1,0h-1.2c0,0-.1,0-.1,0,0,0,0,0,0,.1v.4c0,0,0,.1,0,.2,0,0,.1,0,.2,0h1.1c.1,0,.3,0,.4,0,.1,0,.2.2.3.3,0,.1,0,.2,0,.4v.5c0,.1,0,.2,0,.4,0,.1-.1.2-.2.2,0,0-.2,0-.3,0h-1.4s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1,22.3h.4s0,0,0,0v3.2s0,0,0,0h-.4s0,0,0,0v-3.2s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,22.8h-1s0,0,0,0v-.4s0,0,0,0h2.6s0,0,0,0v.4s0,0,0,0h-1s0,0,0,0v2.7s0,0,0,0h-.4s0,0,0,0v-2.7s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,22.3h.5s0,0,0,0l1.3,3.2s0,0,0,0h-.4s0,0,0,0l-.3-.8s0,0,0,0h-1.5s0,0,0,0l-.3.8s0,0,0,0h-.4s0,0,0,0l1.3-3.2s0,0,0,0ZM80.3,24.2l-.5-1.2s0,0-.1,0l-.5,1.2s0,0,0,0h1s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,24.5h-.8s0,0,0,0v1s0,0,0,0h-.4s0,0,0,0v-3.2s0,0,0,0h1.9c.1,0,.2,0,.3,0,0,0,.2.1.2.2,0,.1,0,.2,0,.3v.8c0,.2,0,.4-.2.5,0,.1-.2.2-.3.2s0,0,0,0l.6.9s0,0,0,0h-.4s0,0,0,0l-.7-1s0,0,0,0ZM83.7,24c0,0,.1,0,.1,0,0,0,0,0,0-.2v-.8c0,0,0-.1,0-.1s0,0-.1,0h-1.3s0,0,0,0v1.1s0,0,0,0h1.3Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,22.3h.4s0,0,0,0v3.2s0,0,0,0h-.4s0,0,0,0v-3.2s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,22.3h.5s0,0,0,0l1.3,3.2s0,0,0,0h-.4s0,0,0,0l-.3-.8s0,0,0,0h-1.5s0,0,0,0l-.3.8s0,0,0,0h-.4s0,0,0,0l1.3-3.2s0,0,0,0ZM87.8,24.2l-.5-1.2s0,0-.1,0l-.5,1.2s0,0,0,0h1s0,0,0,0Z",
    fill: "#1a1918"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,40.6c1.9-1.3,4.2-1.2,5.9.4.4.4.7.8,1.2,1.1.8.7,1.9,1.3,2.9.8.5-.2.8-.6,1.1-1.1,0,0,0,0,0,0,0,0,0,0,0,0-.4.7-1.1,1.3-1.9,1.3-1.4,0-2.4-1.2-3.3-2.1-1.7-1.6-4-1.7-5.9-.4h0Z",
    fill: "#2294c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,29.6h-35.2c-.7,0-1.3.5-1.3,1.2v8.5c0,.7.6,1.2,1.3,1.2h35.2c.7,0,1.3-.5,1.3-1.2v-8.5c0-.7-.6-1.2-1.3-1.2ZM72.3,30.7c-.2,0-.3-.1-.3-.3s.1-.3.3-.3.3.1.3.3-.1.3-.3.3Z",
    fill: "#dd4f13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.4,37.8h-3.8v-4.9h3.8v1h-2.6v.9h2.4v1h-2.4v.9h2.6v1Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,34v3.9h-1.2v-3.9h-1.6v-1.1h4.4v1.1h-1.6Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9,37.8l-.3-.9h-2.1l-.3.9h-1.3l2-4.9h1.2l2,4.9h-1.3ZM69.6,34.3l-.6,1.6h1.3l-.6-1.6Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1,32.9c1.1,0,1.8.7,1.8,1.7s-.7,1.7-1.9,1.7h-1.2v1.5h-1.2v-4.9h2.4ZM74.9,35.3c.5,0,.8-.3.8-.7s-.3-.7-.8-.7h-1.1v1.4h1.1Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,37.8l-.3-.9h-2.1l-.3.9h-1.3l2-4.9h1.2l2,4.9h-1.3ZM79.1,34.3l-.6,1.6h1.3l-.6-1.6Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7,34.6c1.1,0,1.7.6,1.7,1.6s-.7,1.7-1.9,1.7-1.9-.6-1.9-1.7l1.1-.2c0,.6.4.9.8.9s.7-.3.7-.7-.3-.6-.7-.6h-1.7v-2.7h3.3v1h-2.2v.7s.7,0,.7,0Z",
    fill: "#fdfdfd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "80.1 39 80.5 39.8 80.9 40.6 79.6 42.1 78.8 40.3 79.5 39.6 80.1 39 80.1 39",
    fill: "#63c3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1,39c0,.9-.2,1.9-.5,3h0s0,0,0,0h0c.3-1.1.6-2.1.5-3.1h0s0,0,0,0h0Z",
    fill: "#44d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,40.2c.1,0,.7,0,1.3,0,.3,0,.5.2.7.2,0,0,.1,0,.2,0h0s0,0,0,0c0,0-.1,0-.2,0-.2,0-.5-.2-.7-.2-.6-.1-1.2,0-1.3,0h0s0,0,0,0h0Z",
    fill: "#44d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7,40.5s0,0,0,0c0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0-.2,0,0,0,0,0,0,0-.2,0-.5,0-.7,0,0-.1,0-.2,0-.3.2,0,.4.1.5.2h0s0,0,0,0h0Z",
    fill: "#44b7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,40.3c0,.1,0,.2,0,.3-.5-.1-.6-.1-1.1-.4,0,0,.2,0,.4,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.3,0,.5,0h0Z",
    fill: "#44b7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,40.7h0s0,0,0,0c0-.1,0-.2,0-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.3h0Z",
    fill: "#2cf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,30.5c-.2,0-.3,0-.5,0h0s0,0,0,0c.3-.7,1-1.1,1.7-1.2.3,0,.5,0,.6.2.1.2,0,.4,0,.6-.1.2-.3.3-.5.3-.4.1-.8.2-1.2.2ZM72.5,30.3c.5,0,1,0,1.4-.2.1,0,.3-.1.4-.3,0,0,.1-.3,0-.4,0-.1-.3-.1-.4-.1-.6,0-1.1.4-1.4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4,30.7c-.3,0-.7,0-1-.1,0,0-.2,0-.2-.1,0,0-.1-.2-.1-.3,0-.1.1-.3.3-.3.7-.2,1.5,0,2,.6h0s0,.1,0,.1c-.3,0-.6.1-1,.1ZM71,29.9c-.2,0-.3,0-.5,0,0,0-.2,0-.2.2,0,0,0,0,0,.1,0,0,.1,0,.2,0,.5.2,1.1.2,1.6,0-.3-.3-.8-.5-1.2-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4,31.9s0,0,0,0c0,0,0-.1,0-.1.5-.2.9-.8.9-1.4,0,0,0,0,0,0,0,0,0,0,0,0,0,.7-.4,1.3-1,1.6,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1,31.3s0,0,0,0c-.4-.1-.7-.5-.8-.9,0,0,0,0,0-.1,0,0,0,0,.1,0,0,.4.3.7.7.8,0,0,0,0,0,.1,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 26.5,
    width: 0.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 27,
    width: 0.2,
    height: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,29.3c.7-.8,1.8-1.2,2.9-1.2.5,0,1.1.1,1.6.3.5.2,1,.5,1.3.9,1.7,1.8,2.3,4.3,4.7,1.3,0,0,0,0,0,0,0,0,0,0,0,0-.3.4-.7.8-1.2,1.1-.8.6-1.6.2-2.1-.6-.5-.6-.9-1.3-1.5-1.9-.4-.4-.8-.7-1.3-.9-.5-.2-1-.3-1.6-.3-1.1,0-2.2.4-2.9,1.2h0Z",
    fill: "#e58b0a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "95.6 27.5 95.7 28.6 95.9 29.6 93.8 30.7 93.6 28.4 94.6 27.9 95.6 27.5 95.6 27.5",
    fill: "#fc0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,27.6c-.2,1-1,2.1-1.7,3.1h0s0,0,0,0h0c.8-1.1,1.5-2.1,1.8-3.2h0s0,0,0,0h0Z",
    fill: "#fea000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6,28.4c.2,0,.8.2,1.4.5.3.2.5.4.7.6,0,0,.1,0,.2.1h0s0,0,0,0c0,0-.1,0-.2-.2-.2-.2-.4-.4-.7-.5-.6-.3-1.3-.5-1.4-.5h0s0,0,0,0h0Z",
    fill: "#fea000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,29.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0-.2,0,0,0,0,0,0,0-.2,0-.6-.2-.8-.3,0-.1.1-.2.2-.3.2.1.4.3.5.4h0s0,0,0,0h0Z",
    fill: "#dcb000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,28.9c0,.1-.1.2-.2.3-.6-.3-.7-.4-1.1-.9,0,0,.2,0,.4.1,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.4.2.5.3h0Z",
    fill: "#dcb000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8,29.3h0s0,0,0,0c0-.1.1-.2.2-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,.1-.1.2-.2.3h0Z",
    fill: "#dc8700",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.1,41.6c-.2-1.1-1-2-1.9-2.5-.5-.3-1-.4-1.5-.5-.5,0-1.1,0-1.6.1-.5.2-1,.4-1.5.6-.7.3-1.6.8-2.3.4-.7-.5-.8-1.4-.9-2.2,0,0,0,0,0,0,0,0,0,0,0,0,.5,3.8,2.3,2,4.7,1.2.5-.1,1.1-.2,1.6-.1.5.1,1.1.3,1.5.6.9.5,1.6,1.5,1.9,2.5h0Z",
    fill: "#2b660c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "50.3 34 49.6 34.9 49 35.8 50.4 37.7 51.6 35.7 50.9 34.8 50.3 34 50.3 34",
    fill: "#b2d72d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2,34.1c-.3,1,0,2.3.1,3.6h0c0,0,0,0,0,0h0c-.2-1.3-.4-2.6,0-3.6h0s0,0,0,0h0Z",
    fill: "#289119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6,35.7c-.2,0-.8-.2-1.5-.1-.3,0-.6,0-.9.2,0,0-.1,0-.2,0h0s0,0,0,0c0,0,.1,0,.2,0,.2,0,.6-.1.9-.2.7,0,1.4.1,1.5.2h0s0,0,0,0h0Z",
    fill: "#289119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,35.7s0,0-.1,0c0,0,0,0,0,0,0,0-.1,0-.1,0,0,0,0,0,.2,0,0,0,0,0,0,0,.2,0,.6,0,.9,0,0-.2,0-.2,0-.4-.2,0-.5,0-.7.1h0s0,0,0,0h0Z",
    fill: "#99b92a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2,35.6c0,.2,0,.2,0,.4.6,0,.7,0,1.4-.3,0,0-.2,0-.4,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,0,0-.2,0-.2,0-.4,0-.6,0h0Z",
    fill: "#99b92a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,36h0s0,0,0,0c0-.2,0-.2,0-.4,0,0,0,0,0,0,0,0,0,0,0,0,0,.2,0,.2,0,.4h0Z",
    fill: "#207915",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLomasetapa5Horizontal);
export default __webpack_public_path__ + "static/media/Lomas etapa 5 Horizontal.47bc20965accab0d64135f6a1a27ab2b.svg";
export { ForwardRef as ReactComponent };